<template>
  <mf-loading-dialog :loading="$apollo.loading">
    <div>
      <v-row class="px-3 pb-3" justify="end">
        <mf-button id="new-whatsapp-flow" data-userflow-id="new-whatsapp-flow" icon="add" label="Novo fluxo" @click="$router.push('whatsapp/fluxos/novo')" />
      </v-row>
      <v-card data-userflow-id="whatsapp-flows">
        <v-card-title>
          <div class="card-title">
            <span class="bold table-card-title">
              <slot name="title">Meus fluxos de WhatsApp</slot>
            </span>

            <div class="status-search-group">
              <mf-status-filter v-if="itemsFilter.length > 1" :items="itemsFilter" @input="setFilterResult" />
              <div class="min-width-345">
                <mf-search v-model="search" class="pt-0 mt-0" hide-details placeholder="Busca" />
              </div>
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <paginated-data-table
            ref="table"
            :headers="headers"
            :search="search"
            :query="query"
            :query-variables="queryVariables"
            :custom-items-per-page="10"
            query-name="whatsappFlowMenus"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <mf-icon fill small :color="getStatusLabel(item.active ? 'ACTIVE' : 'DRAFT').color">fiber_manual_record</mf-icon>
                  {{ item.active ? 'Ativo' : 'Rascunho' }}
                </td>

                <td class="nowrap-row">
                  <v-tooltip v-model="showTooltipTitle[item._id]" max-width="250" top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <router-link class="link" :to="{ path: `/campanhas/whatsapp/fluxos/editar/${item._id}` }">
                          {{ item.title | truncate({ length: 24 }) }}
                        </router-link>
                      </span>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </td>

                <td class="nowrap-row">
                  <v-tooltip v-model="showTooltipDescription[item._id]" max-width="250" top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.description | truncate({ length: 48 }) }}</span>
                    </template>
                    <span>{{ item.description }}</span>
                  </v-tooltip>
                </td>

                <td class="nowrap-row">
                  <v-tooltip v-if="item.registers && item.registers.length > 1" right>
                    <template #activator="{ on, attrs }">
                      <span v-bind="attrs" style="cursor: auto" v-on="on">
                        {{ getWhatsappRegisters(item) }}
                      </span>
                    </template>
                    <span v-for="(register, index) in item.registers" :key="index" style="display: block">
                      {{ register.name }} - {{ phoneNumberFormat(register.number) }}
                    </span>
                  </v-tooltip>
                  <span v-else-if="item.registers && item.registers.length === 1">
                    {{ item.registers[0].name }} - {{ phoneNumberFormat(item.registers[0].number) }}
                  </span>
                  <span v-else> - </span>
                </td>

                <td>
                  {{ DateTime.fromISO(item.updated_at).toFormat('dd/MM/yyyy HH:mm:ss') }}
                </td>

                <td>
                  <v-menu>
                    <template v-slot:activator="{ on }">
                      <mf-button type="icon" icon="more_vert" color="cinza-0" v-on:click.native="on.click" />
                    </template>
                    <v-list>
                      <v-list-item @click="$goTo(`/campanhas/whatsapp/fluxos/editar/${item._id}`)">
                        <v-list-item-title>Editar</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteFlow(item)">
                        <v-list-item-title>Deletar</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </paginated-data-table>
        </v-card-text>
      </v-card>
    </div>
  </mf-loading-dialog>
</template>

<script>
import { MUTATION_DELETE_FLOW_MENU, QUERY_WHATSAPP_FLOW_MENUS } from '@/modules/campanhas/whatsapp/graphql'
import { getStatusLabel, getWhatsappRegisters } from '@/config/helpers.js'
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { DateTime } from 'luxon'

export default {
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
  },
  data: () => ({
    DateTime,
    search: '',
    statusToSearch: [],
    showTooltipTitle: {},
    showTooltipDescription: {},
  }),
  computed: {
    query() {
      return QUERY_WHATSAPP_FLOW_MENUS
    },
    itemsFilter() {
      return [
        { label: 'Ativo', value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
        { label: 'Rascunho', value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
      ]
    },
    headers() {
      return [
        {
          text: 'Status',
          value: 'status',
          width: '10%',
        },
        {
          text: 'Título',
          value: 'title',
          width: '25%',
        },
        {
          text: 'Descrição',
          value: 'description',
          width: '20%',
        },
        {
          text: 'Números do Whatsapp',
          value: 'registers',
          sortable: false,
          width: '20%',
        },
        {
          text: 'Última atualização',
          value: 'updated_at',
          width: '20%',
        },
        {
          text: '',
          sortable: false,
          width: '5%',
        },
      ]
    },
    activeFilter() {
      if (this.statusToSearch.includes('ACTIVE') && this.statusToSearch.includes('DRAFT')) {
        return undefined
      }
      if (this.statusToSearch.includes('ACTIVE') && !this.statusToSearch.includes('DRAFT')) {
        return true
      }
      if (!this.statusToSearch.includes('ACTIVE') && this.statusToSearch.includes('DRAFT')) {
        return false
      }
      return undefined
    },
    queryVariables() {
      return {
        active: this.activeFilter,
      }
    },
  },
  methods: {
    getStatusLabel,
    getWhatsappRegisters,
    phoneNumberFormat,
    setFilterResult(value) {
      this.statusToSearch = value.length ? value : this.itemsFilter.map((item) => item.value)
    },
    async deleteFlow(flow) {
      const confirmed = await this.$confirm({
        title: 'Remover fluxo',
        message: `Tem certeza que deseja remover o fluxo "${flow.title}"?`,
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.$refs.table.paginationLoading = true
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_DELETE_FLOW_MENU,
          variables: {
            _id: flow._id,
          },
        })
        this.$snackbar({ message: 'Fluxo apagado.', snackbarColor: 'success' })
      } catch (e) {
        console.warn(e)
        this.$snackbar({ message: 'Erro ao apagar fluxo', snackbarColor: 'error' })
        this.$refs.table.paginationLoading = false
        return
      }
      try {
        await this.$refs.table.waitAndGetData()
      } catch (e) {
        console.warn(e)
        this.$snackbar({ message: 'Erro ao buscar fluxos.', snackbarColor: 'error' })
      }
      this.$refs.table.paginationLoading = false
    },
  },
}
</script>
